module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-19.ad82e60f.jpg";